import { Component, OnInit, ViewChild } from '@angular/core';
import { SwiperOptions } from 'swiper/types';
import { SwiperComponent } from 'swiper/angular';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-feedback-style-two',
    templateUrl: './feedback-style-two.component.html',
})
export class FeedbackStyleTwoComponent implements OnInit {
    @ViewChild('swiper') swiper?: SwiperComponent;


    isToggled = false;

    constructor(
        public themeService: ThemeCustomizerService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void {}

    testimonialsSlides: SwiperOptions = {
		loop: true,
		navigation: false,
		pagination: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
            pauseOnMouseEnter: true
		},
		centeredSlides: true,
		breakpoints: {
			0: {
				slidesPerView: 1
			},
			576: {
				slidesPerView: 2
			},
			768: {
				slidesPerView: 2
			},
			1200: {
				slidesPerView: 3
			}
		}
    }

}